module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "map"
    }
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "380px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 16,
      "sensor": false
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.center,
      "clickable": true,
      "draggable": false
    }
  })], 1)], 1), _vm._v(" "), _c('main', {
    attrs: {
      "id": "contact_page"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "main_title a_left"
  }, [_c('h2', {
    directives: [{
      name: "lang",
      rawName: "v-lang.contacto",
      modifiers: {
        "contacto": true
      }
    }]
  })]), _vm._v(" "), _c('contact-form', {
    attrs: {
      "type": "extend"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "main_title a_left"
  }, [_c('h2', {
    directives: [{
      name: "lang",
      rawName: "v-lang.get_in_touch",
      modifiers: {
        "get_in_touch": true
      }
    }]
  })]), _vm._v(" "), _c('contact-info'), _vm._v(" "), _c('div', {
    staticClass: "social_media"
  }, [_c('social-item', {
    attrs: {
      "type": "facebook"
    }
  }), _vm._v(" "), _c('social-item', {
    attrs: {
      "type": "twitter"
    }
  }), _vm._v(" "), _c('social-item', {
    attrs: {
      "type": "googleplus"
    }
  }), _vm._v(" "), _c('social-item', {
    attrs: {
      "type": "pinterest"
    }
  }), _vm._v(" "), _c('social-item', {
    attrs: {
      "type": "linkedin"
    }
  }), _vm._v(" "), _c('social-item', {
    attrs: {
      "type": "youtube"
    }
  }), _vm._v(" "), _c('social-item', {
    attrs: {
      "type": "instagram"
    }
  })], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ee72c04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/contact/Contact.vue
// module id = 386
// module chunks = 0